export default "__VITE_ASSET__w2Rf28kS__ 740w";